import React, { Component } from "react";
class HandHover extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <div className="right-content bg-gray p-5 handhover-page">
          <div className="col-md-12">
            <div className="row align-items-center">
              <div className="col-md-6 mb-5 mt-5 mt-md-0 mb-md-0">
                <h2 className="font-weight-normal mb-0 handhovertext">
                  Hand Hover Task
                </h2>
              </div>
              <div className="col-md-6 text-right">
                <a href="#" className="btn btn-secondary">
                  Add Task
                </a>
              </div>
            </div>
          </div>

          <div className="col-md-12 task-box mt-4">
            <div className="row">
              <div className="col-md-4">
                <div className="task-column">
                  <div className="d-flex task-title mb-3">
                    <h5>New Task</h5>
                    <span className="more-icon ml-auto">
                      <a href="#">
                        <img alt="more" src="../../images/more-icon.svg" />
                      </a>
                    </span>
                  </div>
                  <div className="task-list bg-white">
                    <h5 className="font-weight-normal mb-4">Revamp Home Page</h5>
                    <div className="progress">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: "25%", background: "#F64E60" }}
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <div className="lable-sec col-md-12 mt-4">
                      <div className="row">
                        <div className="col-md-6 p-0 paper-text">
                          <img src="../../images/paper.svg" />
                          <span className="doc-number">
                            <strong>12</strong>
                          </span>
                          <span className="badge badge-success">3 Weeks</span>
                        </div>
                        <div className="col-md-6 p-0 text-right">
                          <div className="user-list d-flex justify-content-end">
                            <span className="user-t">S</span>
                            <span className="user-t">L</span>
                            <img src="../../images/user.png" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="task-list bg-white">
                    <h5 className="font-weight-normal mb-4">
                      New Feature: Radio Play with Toggle on-off
                    </h5>
                    <div className="progress">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: "100%", background: "#4AB58E" }}
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <div className="lable-sec col-md-12 mt-4">
                      <div className="row">
                        <div className="col-md-6 p-0 paper-text">
                          <img src="../../images/paper.svg" />
                          <span className="doc-number">
                            <strong>12</strong>
                          </span>
                          <span className="badge badge-danger">2 days</span>
                        </div>
                        <div className="col-md-6 p-0 text-right">
                          <div className="user-list d-flex justify-content-end">
                            <span className="user-t">S</span>
                            <span className="user-t">L</span>
                            <img alt="" src="../../images/user.png" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="task-list bg-white">
                    <h5 className="font-weight-normal mb-4">
                      New Microsite for Promotion
                    </h5>
                    <div className="progress">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: "100%", background: "#4AB58E" }}
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <div className="lable-sec col-md-12 mt-4">
                      <div className="row">
                        <div className="col-md-6 p-0 paper-text">
                          <img src="../../images/paper.svg" />
                          <span className="doc-number">
                            <strong>12</strong>
                          </span>
                          <span className="badge badge-danger">2 days</span>
                        </div>
                        <div className="col-md-6 p-0 text-right">
                          <div className="user-list d-flex justify-content-end">
                            <span className="user-t">S</span>
                            <span className="user-t">L</span>
                            <img src="../../images/user.png" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="new-task text-center">
                    <a href="#">
                      <img src="../../images/plus-icon.svg" className="mr-2" />
                      New Task
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="task-column">
                  <div className="d-flex task-title mb-3">
                    <h5>Completed</h5>
                    <span className="more-icon ml-auto">
                      <a href="#">
                        <img src="../../images/more-icon.svg" />
                      </a>
                    </span>
                  </div>
                  <div className="task-list bg-white">
                    <h5 className="font-weight-normal mb-4">
                      Profile Page Redesign
                    </h5>
                    <div className="progress">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: "85%", background: "#4AB58E" }}
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <div className="lable-sec col-md-12 mt-4">
                      <div className="row">
                        <div className="col-md-6 p-0 paper-text">
                          <img src="../../images/paper.svg" />
                          <span className="doc-number">
                            <strong>12</strong>
                          </span>
                          <span className="badge badge-success">3 Weeks</span>
                        </div>
                        <div className="col-md-6 p-0 text-right">
                          <div className="user-list d-flex justify-content-end">
                            <span className="user-t">S</span>
                            <span className="user-t">L</span>
                            <img src="../../images/user.png" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="task-list bg-white">
                    <h5 className="font-weight-normal mb-4">
                      Android and iOS Mobile Apps Revisit
                    </h5>
                    <div className="progress">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: "65%", background: "#8950FC" }}
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <div className="lable-sec col-md-12 mt-4">
                      <div className="row">
                        <div className="col-md-6 p-0 paper-text">
                          <img src="../../images/paper.svg" />
                          <span className="doc-number">
                            <strong>12</strong>
                          </span>
                          <span className="badge badge-danger">2 days</span>
                        </div>
                        <div className="col-md-6 p-0 text-right">
                          <div className="user-list d-flex justify-content-end">
                            <span className="user-t">S</span>
                            <span className="user-t">L</span>
                            <img src="../../images/user.png" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="new-task text-center">
                    <a href="#">
                      <img src="../../images/plus-icon.svg" className="mr-2" />
                      New Task
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default HandHover;
